import { Button, Card, Form, notification, Popconfirm, Tooltip } from 'antd'
import moment from 'moment'
import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import AbstractActivityList from '../AbstractActivityList'
import { FormUtils, TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import {
  ChooseEmailModal,
  chooseEmailModalFxn,
  DisplayDate
} from '../../../../components/_utils/appUtils'
import Request, { API_URL } from '../../../../request'
import { getPushPathWrapper } from '../../../../routes'
import { SendTemplateEmail } from '../../../email/actions'

import {
  // generateAndDepositXml,
  getAllAbstracts,
  viewGeneratedXml,
  generateAndDepositAbstractXml
} from '../actions'
import  AbstractFilters from '../../views/../views/abstractPages/AbstractFilters'
import OnlinePublishAbstractDrawer from '../../views/abstractPages/OnlinePublishAbstractDrawer'
// import DOIDrawer from '../drawers/DOIDrawer'

const publishArr = [
  { value: true, display: 'Publish', _id: 'publish' },
  { value: false, display: 'Un-Publish', _id: 'unpublish' }
]

@Form.create()
class DOIAbstract extends Component {
  state = {
    edit: false,
    journalList: [],
    volumeList: [],
    issueList: [],
    isPublished: null,
    slugJournal: null,
    slugVolume: null,
    slugIssue: null,
    abstractId: null, // Updated
    filters: {},
    visibleDrawer: false,
    abstract: {}, // Updated
    total: '',
    visibleActivityList: false
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let {
        dispatch,
        form: { getFieldValue }
      } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'DOI' // Updated to match Abstract schema
      }
      let regExpFilters = []

      // Updated to call getAllAbstracts
      let data = await dispatch(
        getAllAbstracts({ ...obj, regExFilters: regExpFilters })
      )
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => {
    this.table.current.reload()
  }

  reloadTable = data => {
    if (data.fromDate && data.toDate) {
      data['createdAt'] = { // Abstracts usually use createdAt or submittedDate
        $gte: data.fromDate,
        $lte: data.toDate
      }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }

  // Update request to handle abstracts if you have a deleteAbstract API
  deleteAbstract = async data => {
    let resp = await Request.deleteAbstract(data)
    this.reload()
  }

  doiEvents = {
    viewDoiXml: async abstract => {
      let { success, message, filePath } = await this.props.dispatch(
        viewGeneratedXml({ abstractId: abstract._id }) // Updated ID
      )
      if (success) {
        window.open(`${API_URL}${filePath}`, '_blank')
      }
    },
    depositDoiXml: async abstract => {
      let { success, message } = await this.props.dispatch(
        generateAndDepositAbstractXml({ abstractId: abstract._id })
      )
      if (success) {
        notification.success({
          message: message
        })
        this.reload()
      }
    }
  }

  sendMailFxn = record => {
    let { dispatch } = this.props
    chooseEmailModalFxn({
      callback: async email => {
        let obj = {
          abstractId: record._id, // Updated ID
          fromEmail: email,
          emailType: 'acknowledgement',
          template:
            record.publicationCharges > 0 // Updated to abstract charge variable
              ? 'acknowledgementWithCharges'
              : 'acknowledgementWithoutCharges',
          type: 'abstract' // Updated type
        }
        let resp = await dispatch(
          SendTemplateEmail({
            email,
            id: record._id,
            obj,
            template: obj.template
          })
        )
        if (resp && resp.success) {
          notification.success({
            message: resp.message
          })
          this.reload()
        }
      }
    })
  }

  render() {
    const {
      dispatch,
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading
    } = this.props

    const columns = [
      // {
      //   key: 'actions',
      //   title: 'Abstract Id',
      //   width: '85px',
      //   render: (val, record) => (
      //     <Tooltip title="Edit Details">
      //       <a href={`/abstractView/${record._id}`}>{record.abstractNo}</a>
      //     </Tooltip>
      //   )
      // },

      {
        key: 'actions',
        title: 'Abstract No',
        width: '85px',
        render: (val, record) => (
          <Tooltip title="View Details">
            <a href={`/abstract/view/${record._id}`}>
              {record.abstractNo || record.onlineAbstractId}
            </a>
          </Tooltip>
        )
      },
      {
        title: 'Submitted Date',
        key: 'createdAt',
        dataIndex: 'createdAt',
        width: 100,
        render: item => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Abstract Title',
        key: 'doiTitle',
        render: (item, record) => {
          let title = item ? item : record.titleOfAbstract;
          return title ? ReactHtmlParser(title) : null
        }
      },
      {
        title: 'Country',
        key: 'country',
        dataIndex: 'country'
      },
      {
        title: 'Author',
        key: 'authorName', // Updated to abstract schema field
        dataIndex: 'authorName'
      },
      {
        title: 'Email',
        key: 'email', // Updated to abstract schema field
        dataIndex: 'email'
      },
      {
        title: 'Acceptance Date',
        key: 'approvedAbstractPaymentDate', // Updated to abstract schema field
        dataIndex: 'approvedAbstractPaymentDate',
        width: 100,
        render: item => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Revised Date', // Replaced Galley Proof with Revised for Abstracts
        key: 'revisedAbstractDate',
        dataIndex: 'revisedAbstractDate',
        width: 100,
        render: item => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'DOI Date',
        key: 'doiProcessDate', // Mapped to the new field
        dataIndex: 'doiProcessDate',
        width: 100,
        render: item => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Action',
        key: 'Action',
        render: (item, record) => {
          return (
            <>
              <Button
                className={'roundSmallBtn'}
                onClick={() =>
                  this.setState({ visibleDrawer: true, abstract: record })
                }>
                Online Publication
              </Button>
              <Button
                className={'roundSmallBtn'}
                onClick={() => this.doiEvents.viewDoiXml(record)}>
                View DOI XML
              </Button>
              <Popconfirm
                placement="topLeft"
                title={`Are you sure you want to Generate XML?`}
                onConfirm={() => this.doiEvents.depositDoiXml(record)}
                okText="Yes"
                cancelText="No">
                <Button className={'roundSmallBtn'}>Deposit DOI XML</Button>
              </Popconfirm>
              <Button
                className={'roundSmallBtn'}
                onClick={() =>
                  this.setState({ visibleActivityList: true, abstract: record }) // Updated state
                }>
                Abstract Activities
              </Button>
            </>
          )
        }
      }
    ]

    return (
      <PageHeaderWrapper title={`DOI Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters
            callback={data => {
              this.reloadTable(data)
            }}
          />
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
          />
        </Card>
        {/*{this.state.visibleDrawer ? (*/}
        {/*  <OnlinePublishDrawer*/}
        {/*    visible={this.state.visibleDrawer}*/}
        {/*    abstractId={this.state.abstract._id} // Updated prop*/}
        {/*    abstract={this.state.abstract} // Updated prop*/}
        {/*    Id={this.state.abstract._id}*/}
        {/*    callback={this.reload}*/}
        {/*    edit={false}*/}
        {/*    onClose={() => this.setState({ visibleDrawer: false })}*/}
        {/*  />*/}
        {/*) : null}*/}
        {this.state.visibleActivityList ? (
          <AbstractActivityList
            abstractId={this.state.abstract._id}
            abstractNo={this.state.abstract.abstractNo}
            visible={this.state.visibleActivityList}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        ) : null}
        {this.state.visibleDrawer ? (
          <OnlinePublishAbstractDrawer
            visible={this.state.visibleDrawer}
            abstractId={this.state.abstract._id}
            abstract={this.state.abstract}
            Id={this.state.abstract._id}
            callback={this.reload}
            edit={false}
            onClose={() => this.setState({ visibleDrawer: false })}
          />
        ) : null}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DOIAbstract)